import React, { useState } from 'react';

import { Suggestion } from '../custom-extensions/SlashMenuRenderer';

import { SlashMenuItem } from './SlashMenuItem';

const DEFAULT_FOCUSED_INDEX = -1;
export const SlashMenu = ({
  items: actions,
  command,
}: {
  items: Suggestion[];
  command: (action: Suggestion) => void;
}) => {
  const [focusedIndex, setFocusedIndex] = useState(DEFAULT_FOCUSED_INDEX);

  /**
   * This use effect is responsible of keyboard navigation
   * It updates the focused index based on the arrow keys
   * and triggers the command when the enter key is pressed.
   * The focused index will be passed to the action item
   * that will set its focused state to true.
   */
  React.useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        if (focusedIndex < actions.length - 1) {
          setFocusedIndex(focusedIndex + 1);
        } else {
          setFocusedIndex(DEFAULT_FOCUSED_INDEX);
        }
      }
      if (event.key === 'ArrowUp') {
        event.preventDefault();
        if (focusedIndex > 0) {
          setFocusedIndex(focusedIndex - 1);
        } else {
          setFocusedIndex(DEFAULT_FOCUSED_INDEX);
        }
      }
      if (event.key === 'Enter') {
        command?.(actions[focusedIndex]);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [focusedIndex, actions, command]);

  return (
    <ul
      className="flex flex-col list-none bg-white border rounded shadow-popover-050 w-[160px]"
      role="menu"
    >
      {actions.map((action, index) => (
        <>
          <SlashMenuItem
            key={action.title}
            action={action}
            index={index}
            command={command}
            focused={focusedIndex === index}
          />
        </>
      ))}
    </ul>
  );
};
